import _ from 'lodash';
import * as api from '../../api';

import { getSourceFieldValue } from '../../utils/form';
import { isPrevisitPharmacy } from '../PharmacyInput/types';
import { PharmacyInput } from '../PharmacyInput';
import { useEffect, useState } from 'react';
import { useAsyncFlow } from '../../hooks/common/useAsyncFlow';

import spacingStyle from '../../styles/spacing.module.css';

interface Props {
  value: string;
  updateFieldValue: (value: string) => void;
  saveFieldValue: (value: string) => void;
  practice?: api.Practice.Practice | null;
}

export function NcpdpPharmacy({
  value,
  updateFieldValue,
  saveFieldValue,
  practice,
}: Props) {
  const parsed = getSourceFieldValue(
    value,
    api.PrevisitFormTemplateFieldConfig.Primitive.PatientNCPDPPharmacies,
  )?.[0];
  const initPharmacy = isPrevisitPharmacy(parsed) ? parsed : undefined;

  const [pharmacies, setPharmacies] = useState<api.Pharmacy.PrevisitPharmacy[]>(
    [],
  );
  const [patientPharmacies, setPatientPharmacies] = useState<
    api.Pharmacy.PrevisitPharmacy[]
  >([]);
  const { execute: fetchPharmacies, pending } = useAsyncFlow(async () => {
    const allPharmacies: api.Pharmacy.PrevisitPharmacy[] = [];
    let pagedPharmacies: api.Pharmacy.PrevisitPharmacy[];
    let page = 0;
    const limit = 500;
    do {
      pagedPharmacies = await api.client.Pharmacy.findVerifiedPharmacies({
        page,
        limit,
        state: practice?.state,
      });
      allPharmacies.push(...pagedPharmacies);
      page++;
    } while (pagedPharmacies.length !== 0);
    if (allPharmacies.length) {
      setPharmacies(_.uniqBy(allPharmacies, 'ncpdpId'));
    }
    // Filter by state give zero result, in the case let's get all ncpdp verified pharmacies
    page = 0;
    do {
      pagedPharmacies = await api.client.Pharmacy.findVerifiedPharmacies({
        page,
        limit,
      });
      allPharmacies.push(...pagedPharmacies);
      page++;
    } while (pagedPharmacies.length !== 0);
    setPharmacies(_.uniqBy(allPharmacies, 'ncpdpId'));
    const patientPharmacies = await api.client.Patient.findPatientPharmacies();
    setPatientPharmacies(patientPharmacies);
  });

  useEffect(() => {
    fetchPharmacies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={spacingStyle.MtMedium}>
      <PharmacyInput
        pending={pending}
        pharmacies={pharmacies}
        patientPharmacies={patientPharmacies}
        fallbackCoordinates={{
          longitude: practice?.longitude ?? null,
          latitude: practice?.latitude ?? null,
        }}
        initPharmacy={initPharmacy}
        onChange={(pharmacy) => {
          const stringValue = JSON.stringify(pharmacy ? [pharmacy] : []);
          saveFieldValue(stringValue);
          updateFieldValue(stringValue);
        }}
      />
    </div>
  );
}
